import './bakskola'
import './faq'
import './filter'
import './kontakt'
import './recept'
import './scripts'
import './search'
import './slideshow'
import './videoPlayer'